var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDishwasher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8895 10.1921L11.1778 10.9037L17.0703 16.7962L15.892 17.9746L9.99947 12.0829L4.10697 17.9746L2.92864 16.7962L10.7111 9.01373C10.2211 7.79956 10.7278 6.05123 12.0611 4.71623C13.6886 3.08956 15.9311 2.69373 17.0703 3.8329C18.2095 4.97206 17.8136 7.21456 16.187 8.84123C14.852 10.1762 13.1036 10.6829 11.8895 10.1921ZM3.5178 3.24373L9.1153 8.84123L6.75864 11.1987L3.51697 7.95706C2.89207 7.33197 2.54102 6.48428 2.54102 5.6004C2.54102 4.71651 2.89207 3.86882 3.51697 3.24373H3.5178ZM15.0078 7.66206C16.0561 6.61456 16.272 5.3904 15.892 5.0104C15.512 4.6304 14.2878 4.84623 13.2403 5.89373C12.1928 6.94206 11.977 8.16623 12.357 8.54623C12.7361 8.9254 13.9603 8.70956 15.0078 7.66206Z",
    fill: "#0A0A28"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDishwasher);
export default __webpack_public_path__ + "static/media/dishwasher.f22db977dbc8557d68ee3a20d0c41a04.svg";
export { ForwardRef as ReactComponent };